import type { ISocial } from "../../../../types/models/social.models.types";
import { usePostHttp } from "../../http.hook";

interface IResponse {
  social: ISocial;
}
export function useSocialApproveAdminHttp() {
  return usePostHttp<null, IResponse>({
    path: "/admin/socials/:id/approve",
  });
}
